import { ReactElement, useCallback } from 'react';

import { TextField as MUITextField } from '@mui/material';

import { TextFieldProps, Event } from './types';

import { useBoolean } from '../../common/hooks';
import ErrorAdornment from '../ErrorAdornment';

export default function TextField(props: TextFieldProps): ReactElement {
  const {
    errorMessage,
    InputProps,
    autoComplete = 'off',
    type = 'text',
    onFocus,
    onBlur,
    ...rest
  } = props;

  // Controls when textfield is hovered over
  const [hover, setHover] = useBoolean();

  // Controls when textfield is in focus
  const [focus, setFocus] = useBoolean();

  const handleFocus = useCallback((event: Event) => {
    setFocus.on();

    if (onFocus) {
      onFocus(event);
    }
  }, []);

  const handleBlur = useCallback((event: Event) => {
    setFocus.off();

    if (onBlur) {
      onBlur(event);
    }
  }, []);

  return (
    <MUITextField
      autoComplete={type === 'password' ? 'new-password' : autoComplete}
      color='primary'
      error={!!errorMessage}
      onMouseEnter={() => setHover.on()}
      onMouseLeave={() => setHover.off()}
      onFocus={handleFocus}
      onBlur={handleBlur}
      type={type}
      variant='standard'
      InputProps={
        InputProps || {
          autoComplete: type === 'password' ? 'new-password' : autoComplete,
          endAdornment: (
            <ErrorAdornment
              display={!!errorMessage}
              errorMessage={errorMessage}
              openErrorTooltip={focus || hover}
            />
          )
        }
      }
      {...rest}
    />
  );
}
